import { render, staticRenderFns } from "./form-provider.vue?vue&type=template&id=858a33c2&"
import script from "./form-provider.vue?vue&type=script&lang=ts&"
export * from "./form-provider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports